import React from 'react';

/* ── SVG Badge Icons (FaveCard-style illustrated stamps) ── */
export const BadgeStarSvg = ({ size = 20, color = '#F59E0B' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M12 2l2.9 5.9L21 9.2l-4.5 4.4 1.1 6.3L12 17.2l-5.6 2.7 1.1-6.3L3 9.2l6.1-1.3z" fill={color} stroke={color} strokeWidth="0.5"/>
    <path d="M12 5.5l1.8 3.6 4 .6-2.9 2.8.7 4-3.6-1.9-3.6 1.9.7-4-2.9-2.8 4-.6z" fill="#FEF3C7"/>
  </svg>
);

export const BadgeMedalSvg = ({ size = 20, color = '#2563EB' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M8 2l2 6h-4l4 4-2 6 4-3 4 3-2-6 4-4h-4l2-6" fill={color} opacity="0.15"/>
    <circle cx="12" cy="14" r="5" fill={color}/>
    <circle cx="12" cy="14" r="3.2" fill="white"/>
    <path d="M12 12.5l.9 1.8 2-.3-1.4 1.4.3 2L12 16.2l-1.8 1.2.3-2-1.4-1.4 2 .3z" fill={color}/>
    <path d="M9.5 2h1.5l-1 4h-2z M14.5 2h-1.5l1 4h2z" fill={color} opacity="0.4"/>
  </svg>
);

export const BadgeCheckSvg = ({ size = 20, color = '#16A34A' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M12 1l2.4 3.3 4-.8-1.2 3.9 3.1 2.6-3.5 2.1.4 4.1-3.8-1.5L12 18l-1.4-3.3-3.8 1.5.4-4.1L3.7 10l3.1-2.6L5.6 3.5l4 .8z" fill={color}/>
    <path d="M9.5 12l2 2 3.5-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const BadgeStampSvg = ({ size = 20, color = '#DC2626' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <rect x="6" y="14" width="12" height="3" rx="1" fill={color} opacity="0.3"/>
    <rect x="4" y="17" width="16" height="4" rx="2" fill={color}/>
    <rect x="7" y="5" width="10" height="10" rx="5" fill={color}/>
    <path d="M10 10l1.5 1.5 3-3" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const BADGE_ICONS = {
  'badge-star':  { label: 'Étoile dorée', Component: BadgeStarSvg, defaultColor: '#F59E0B' },
  'badge-medal': { label: 'Médaille',     Component: BadgeMedalSvg, defaultColor: '#2563EB' },
  'badge-check': { label: 'Badge check',  Component: BadgeCheckSvg, defaultColor: '#16A34A' },
  'badge-stamp': { label: 'Tampon encreur', Component: BadgeStampSvg, defaultColor: '#DC2626' },
};

export const AppleIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
  </svg>
);

export const COLOR_PRESETS = [
  { id: 'blue', primary: '#2563EB', secondary: '#FFFFFF', name: 'Ocean Blue' },
  { id: 'purple', primary: '#7C3AED', secondary: '#FFFFFF', name: 'Royal Purple' },
  { id: 'green', primary: '#059669', secondary: '#FFFFFF', name: 'Forest Green' },
  { id: 'red', primary: '#DC2626', secondary: '#FFFFFF', name: 'Ruby Red' },
  { id: 'orange', primary: '#EA580C', secondary: '#FFFFFF', name: 'Sunset Orange' },
  { id: 'pink', primary: '#DB2777', secondary: '#FFFFFF', name: 'Hot Pink' },
  { id: 'teal', primary: '#0D9488', secondary: '#FFFFFF', name: 'Teal' },
  { id: 'indigo', primary: '#4F46E5', secondary: '#FFFFFF', name: 'Indigo' },
  { id: 'black', primary: '#18181B', secondary: '#FAFAFA', name: 'Midnight' },
  { id: 'gold', primary: '#B45309', secondary: '#FEF3C7', name: 'Gold' },
];

/* Stamp icon slugs → emoji shown in the editor and on the scan screen. */
export const ICON_DISPLAY = {
  'star': '\u2B50', 'heart': '\u2764\uFE0F', 'check': '\u2705', 'thumbs-up': '\uD83D\uDC4D',
  'sparkle': '\uD83C\uDF1F', 'magic': '\uD83D\uDCAB', 'trophy': '\uD83C\uDFC6', 'target': '\uD83C\uDFAF',
  'coffee': '\u2615', 'croissant': '\uD83E\uDD50', 'pizza': '\uD83C\uDF55', 'taco': '\uD83C\uDF2E',
  'sushi': '\uD83C\uDF63', 'pancakes': '\uD83E\uDD5E', 'burger': '\uD83C\uDF54', 'cupcake': '\uD83E\uDDC1',
  'bag': '\uD83D\uDECD\uFE0F', 'dress': '\uD83D\uDC57', 'lipstick': '\uD83D\uDC84', 'shoe': '\uD83D\uDC60',
  'diamond': '\uD83D\uDC8E', 'flower': '\uD83C\uDF38', 'gift': '\uD83C\uDF81', 'key': '\uD83D\uDD11',
  'steak': '\uD83E\uDD69', 'meat': '\uD83C\uDF56', 'bacon': '\uD83E\uDD53', 'cow': '\uD83D\uDC04',
  'circle': '\u25CF', 'star-alt': '\u2605', 'heart-alt': '\u2665', 'diamond-alt': '\u2726',
};
